import DetailsHeader from 'app/components/common/reports/DetailsHeader'

import { useReportAllSchoolsDto } from '../../../_common/useReportAllSchoolsDto'
import { useReportSummaryDto } from '../../../_common/useReportSummaryDto'
import { NoGroupTable } from './NoGroupTable'


export const NoGroup = () => {
  const allSchoolsDto = useReportAllSchoolsDto()
  const summaryDto = useReportSummaryDto()

  if (!allSchoolsDto || !summaryDto) return null

  return (
    <>
      <DetailsHeader reportTitle="Дотации" />
      <NoGroupTable
        allSchoolsDto={allSchoolsDto}
        summaryDto={summaryDto}
      />
    </>
  )
}
